import type { SourceInformationProps } from './types';
import { NYLAS_V3 } from 'Constants/featureFlags';
import useWarningMessage from 'Hooks/contactSources/useWarningMessage';
import useFeatureFlags from 'Hooks/featureFlags/useFeatureFlags';
import { MobXProviderContext, observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';
import { isV2SourceType, shouldShowWarning } from 'Utils/contactSyncSource';
import { Styled } from './index.styles';

export const SourceInformation: React.FC<SourceInformationProps> = observer(
  ({ source }) => {
    const navigate = useNavigate();
    const { person: personStore } =
      React.useContext<RootStoreProps>(MobXProviderContext);

    const { [NYLAS_V3]: isNylasV3Enabled } = useFeatureFlags([NYLAS_V3]);

    const sourceType = source?.sourceData.type;
    const isV2Source = isV2SourceType(sourceType);
    const syncState = source?.sourceData.syncState;

    const showWarning = shouldShowWarning(
      isNylasV3Enabled,
      sourceType,
      syncState
    );

    const warningMessage = useWarningMessage(
      showWarning,
      sourceType,
      isV2Source,
      syncState
    );

    return (
      <Styled.Container>
        <Styled.Label>{'Source'}</Styled.Label>

        <Styled.InfoWrapper isSourceStale={showWarning}>
          <Styled.Logo
            src={personStore.mapProperLogoProvide(sourceType, true)}
          />
          <Styled.Email>{source?.email}</Styled.Email>
        </Styled.InfoWrapper>

        {showWarning && (
          <Styled.WarningContainer>
            <Styled.WarningIcon icon="warning-filled" />
            <Styled.Warning>
              <Styled.WarningTitle>{'Warning: '}</Styled.WarningTitle>
              <Styled.WarningText>{warningMessage}</Styled.WarningText>
            </Styled.Warning>

            <Styled.ManageSourcesButton
              onClick={() => {
                void navigate('/addressBook/sources');
              }}
              testid="contacts-sourceInformation"
              variant="primary"
            >
              {'Manage sources'}
            </Styled.ManageSourcesButton>
          </Styled.WarningContainer>
        )}
      </Styled.Container>
    );
  }
);
